import React, { FC, useEffect, useState } from "react";
import { useDispatch, useSelector }       from "react-redux";
import { Button, Form, Icon, Modal }      from "semantic-ui-react";
import RegisterFacility                   from "../../../../application/usecase/facility/RegisterFacility";
import Facility                           from "../../../../domain/facility/Facility";
import FacilityId                         from "../../../../domain/facility/FacilityId";
import FacilityName                       from "../../../../domain/facility/FacilityName";
import FacilityWebReservationTargetType   from "../../../../domain/facility/FacilityWebReservationTargetType";
import { ResKaState }                     from "../../../../index";

const ReservationFacilityRegister: FC = () => {
  const [open, setOpen] = useState(false);
  const registerFacility: RegisterFacility = new RegisterFacility(useDispatch());
  const [name, setName] = useState("");
  const [targetType, setTargetType] = useState(FacilityWebReservationTargetType.AVAILABLE);
  const errors = useSelector((state: ResKaState) => state.errors);

  useEffect(() => {
    setName("");
    setTargetType(FacilityWebReservationTargetType.AVAILABLE);
  }, []);

  return (
    <>
      <Button
        icon
        labelPosition="left"
        onClick={ () => {
          setOpen(true);
          setName("");
        } }
      ><Icon name="add"/>施設・設備を登録する
      </Button>
      <Modal
        open={ open }
      >
        <Modal.Header>施設・設備の登録</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Field required>
              <label>施設・設備名</label>
              <Form.Input
                placeholder="施設・設備名を入力してください"
                onChange={ (event, data) => setName(data.value) }
                error={ errors.has("name") ? {
                  content: errors.getMessage("name"),
                  pointing: "below",
                } : undefined }
              />
            </Form.Field>
            <Form.Field required>
              <label>WEB予約対象設定</label>
              <Form.Radio
                toggle
                label={ targetType === FacilityWebReservationTargetType.AVAILABLE ? "WEB予約対象にする" : "WEB予約対象にしない" }
                checked={ targetType === FacilityWebReservationTargetType.AVAILABLE }
                onClick={ () => {
                  switch (targetType) {
                    default:
                    case FacilityWebReservationTargetType.AVAILABLE:
                      setTargetType(FacilityWebReservationTargetType.NOT_AVAILABLE);
                      break;
                    case FacilityWebReservationTargetType.NOT_AVAILABLE:
                      setTargetType(FacilityWebReservationTargetType.AVAILABLE);
                      break;
                  }
                } }
                error={ errors.has("target_type") ? {
                  content: errors.getMessage("target_type"),
                  pointing: "below",
                } : undefined }
              />
            </Form.Field>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            positive
            icon
            labelPosition="left"
            onClick={ () => registerFacility.execute(new Facility(new FacilityId(), new FacilityName(name), targetType), setOpen) }
          >
            <Icon name="save"/>保存する
          </Button>
          <Button onClick={ () => setOpen(false) }>閉じる</Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default ReservationFacilityRegister;